import { Table, message, Popconfirm, Button, Input, Image } from "antd"
import axios from "axios"
import { useState, useEffect, useContext } from "react"
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons"
import { useHistory } from "react-router-dom"
import { UserContext } from "../Context/UserContext"

const MoviesTable = () => {
    // const [listGame, setListGame] = useState([])
    const [user] = useContext(UserContext)
    const [listMovie, setListMovie] = useState([])
    const [triggerDelete, setTriggerDelete] = useState(false)
    let history = useHistory()

    useEffect(()=>{
        const movies = async () => {
            const result = await axios.get("https://super-bootcamp-backend.sanbersy.com/api/movies")
                .then((res) => {
                    return res.data
                })
                .catch((err) =>{
                    console.log(err)
                })
    
                setListMovie(result)
        }

        movies()
    }, [triggerDelete])

    let genre = listMovie.map((e) => {
        console.log(e.genre)
        return e.genre
    })

   
    let uniqGenre = [...new Set(genre)]

    let genreFilter = []
    uniqGenre.forEach((e) => {
        genreFilter.push({
            text: e,
            value: e
        })
    })

    let rating = listMovie.map((e) =>{
        return e.rating
    })
    
    let uniqRating = [...new Set(rating)]
    
    let ratingFilter = []
    uniqRating.forEach((e) => {
        ratingFilter.push({
            text: e,
            value: e
        })
    })
    
    const columns = [
        {
            title: "No",
            key: "no",
            render: (text) => {
                let index = listMovie.indexOf(text)
                return (
                    <>{index+1}</>
                )
            }
        },
        {
            title: "Image",
            dataIndex: "image_url",
            key: "image",
            render: (record) => {
                return (
                    <Image width={50} height={50}  src={record} preview={false}/>
                )
                
            },
        }, 
        {
            title: "Title",
            dataIndex: "title",
            key: "title",
            sorter: (a,b) => {
                if ( a.title< b.title){
                    return -1;
                }
                if ( a.title> b.title){
                    return 1;
                }
              return 0;
            },
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm}) => {
                console.log(selectedKeys)
                return <Input 
                placeholder="Search..." 
                value={selectedKeys[0]} 
                onChange={(e) => { setSelectedKeys(e.target.value ? [e.target.value] : [])}}
                onPressEnter={() => {confirm()}}
                // onBlur={() => {
                //     confirm()
                // }}
                ></Input>
            }, 
            filterIcon:() => {
                return <SearchOutlined/>
            },
            onFilter: (value, record) => { return record.title && record.title.toLowerCase().includes(value.toLowerCase())}
        }, 
        {
            title: "Genre",
            dataIndex: "genre",
            key: "genre",
            sorter: (a,b) => {
                if ( a.genre< b.genre){
                    return -1;
                }
                if ( a.genre> b.genre){
                    return 1;
                }
              return 0;
            },
            filters: [
                ...genreFilter
            ],
            onFilter: (value, record) => { return record.genre !== null ? record.genre === value : "" }
        }, 
        {
            title: "Year",
            dataIndex: "year",
            key: "year",
            sorter: (a,b) => {
                return a.year - b.year
            }
        }, 
        {
            title: "Rating",
            dataIndex: "rating",
            key: "rating",
            sorter: (a,b) => {
                if ( a.rating< b.rating){
                    return -1;
                }
                if ( a.rating > b.rating){
                    return 1;
                }
              return 0;
            },
            filters: [
                ...ratingFilter
            ],
            onFilter: (value, record) => { return record.rating !== null ? record.rating === value : "" }
        }, 
        {
            title: "Duration",
            dataIndex: "duration",
            key: "duration",
            sorter: (a,b) => {
                if ( a.duration< b.duration){
                    return -1;
                }
                if ( a.duration > b.duration){
                    return 1;
                }
              return 0;
            }
        }, 
        {
            title: "Action",
            key: "action",
            render: (record) => {
                const confirm = (e) => {
                    axios.delete(`https://super-bootcamp-backend.sanbersy.com/api/movies/${record.id}`, {headers: {"Authorization" : "Bearer "+ user.token}}).then((res) => {
                        setTriggerDelete(true)
                        message.success('Data has been deleted successfully')
                    })
                  };
                  
                  const cancel = (e) => {
                    console.log(e);
                    message.error('Click on No');
                  };

            
                return (
                    <>
                        <EditOutlined onClick={() => {history.push(`/table-movies/form/edit/${record.id}`)}} style={{fontSize: "20px", marginRight: "10px", color: "blue"}} />
                        <Popconfirm
                            title="Are you sure to delete this game?"
                            onConfirm={confirm}
                            onCancel={cancel}
                            okText="Yes"
                            cancelText="No"
                        >
                            <DeleteOutlined style={{fontSize: "20px", marginRight: "10px", color: "red"}} />
                        </Popconfirm>
                        
                    </>
                )
            }
        }
    ]

    const HandleChange = (sorter) => {
       console.log(sorter)
    }

    const HandleAdd = () => {
        history.push("/table-movies/form")
    }

    const clearFilters = () => {
        window.location.reload();
    };

    return(
        <>
        <Button type="primary" icon={<PlusOutlined />} size="large" style={{marginBottom: "20px", float: "right"}} onClick={HandleAdd}>
            Tambah Data Movie
        </Button>
        <Button type="primary" size="large" style={{marginBottom: "20px", marginRight:"10px" , float: "right"}} onClick={clearFilters}> Reset All Filter</Button>
        <br/>
        <Table columns={columns} dataSource={listMovie} onChange={HandleChange}/>
        </>
    )
}

export default MoviesTable